
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.476 4.518a.5.5 0 000-.707L11.294.629a.5.5 0 10-.708.707l2.829 2.828-2.829 2.828a.5.5 0 00.708.708l3.182-3.182zM1.769 3.81a.5.5 0 000 .707L4.95 7.7a.5.5 0 10.708-.708L2.829 4.164l2.829-2.828A.5.5 0 104.95.629L1.77 3.81zm12.353-.147h-12v1h12v-1z","fill":"#000C1F"}}),_c('rect',{attrs:{"x":".622","y":"12.664","width":"15","height":"11","rx":"1.5","stroke":"#000C1F","stroke-dasharray":"4 4"}})])
          )
        }
      }
    